import {intersection} from 'lodash'


(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.users.editor', [
    'clientDashboardApp.admin.users.userManagerService',
    'clientDashboardApp.admin.accounts'
  ]).controller("UserEditorCtrl", UserEditorCtrl);

  UserEditorCtrl.$inject = [
    '$q',
    'accountId',
    'pageInfo',
    '$stateParams',
    '$state',
    'homeState',
    'forceUserId',
    'userService',
    'userManagerService',
    '$log',
    'stringService',
    'updateService',
    'accountsService'
  ];

  function UserEditorCtrl(
    $q,
    accountId,
    pageInfo,
    $stateParams,
    $state,
    homeState,
    forceUserId,
    userService,
    userManagerService,
    $log,
    stringService,
    updateService,
    accountsService) {

    var vm = this;
    vm.mode = pageInfo.mode;

    vm.showAccountSelection = false;

    vm.defaultUser = function() {
      return {
        username: '',
        firstName: '',
        lastName: '',
        password: '',
        email: '',
        phoneNumber: '',
        userType: 'Standard',
        alertEmails: false,
        accountId: accountId
      }
    };

    vm.defaultUserPreferences = function() {
      return {
        stickyUrl: false
      }
    };

    vm.pageStrings = stringService.adminStrings(vm.mode);

    vm.taskNotificationSettings = {};

    vm.findUserType = function (userType) {
      return _.findWhere(vm.userTypes, {id: userType})
    };

    function processSuccessfulUserUpsert(response) {
      vm.newUser = response.data;
      const updateInfo = {
        status: "Active",
        type: "user",
        title: "User",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: vm.mode}],
        entity: vm.newUser,
        id: vm.newUser.id,
        name: vm.newUser.username,
        accountId: accountId,
        searchParam: vm.newUser.username
      }
      updateService.registerSuccessfulUpdate(updateInfo);
      $state.go(homeState);
      vm.state = 'UserEditing';
    }
    function handleError(response) {
      var errorDetail = 'Please contact support';

      if(response.data && response.data.error.code) {
        var errorCode = response.data.error.code;

        if(errorCode == 'users.edit.username.duplicate') {
          errorDetail = 'This username already exists. Usernames must be unique.';
        }
      }

      vm.errorMsg = 'Error '+vm.pageStrings.errorAction+' user!';
      vm.errorDetail = errorDetail;
      vm.state = 'UserEditing';
    }

    vm.openResetPasswordModal = function() {
      vm.passwordResetState = "Editing";
      vm.passwordModalCloseText = "Cancel";
      vm.user.password = '';
      vm.user.confirmPassword = '';

      $('#resetPasswordModal').modal();
    };

    vm.updatePassword = function (user) {
      vm.passwordResetState = "Updating";
      userManagerService.updateUserPassword(user).then(function(resp) {
        vm.passwordResetState = "Success";
        vm.passwordModalCloseText = "Close";
      }, function(){
        vm.passwordResetState = "Error";
        vm.passwordModalCloseText = "Close";
      });
    };

    vm.clearResetPasswordModal = function(form) {
      form.$pristine = true;
      form.passwordReset.$pristine = true;
      form.confirmPasswordReset.$pristine = true;
    }

    vm.upsertEditUser = function(isFormValid) {
      vm.state = 'PendingConfirmation';
      vm.formSubmitted = true;

      if(!isFormValid){
        $log.info('Missing user data');
        return;
      }

      vm.user.phoneNumber = vm.cleanPhoneNumber(vm.user.phoneNumber);
      vm.user.permissionOverrides = [];
      for (var permission in vm.additionalPermissions) {
        if (vm.additionalPermissions[permission]) {
          vm.user.permissionOverrides.push(permission);
        }
      }

      (() => {
        if (vm.mode === "create") {
          return userManagerService.addUser(vm.user)
        } else {
          return userManagerService.updateUser(vm.user)
        }
      })().then((x) => {
        processSuccessfulUserUpsert(x)
      }).catch(handleError);
    };

    vm.additionalPermissionsToShow = function() {
      let typePermissions = _.find(vm.userTypes, {id: vm.user.userType}).permissions;   // Permissions the user already has from the selected role
      let additionalPermissions = ["ReviewBuilderAccess"];
      if (vm.userMakingEdits.permissions.indexOf("EditInsights") !== -1 || vm.userMakingEdits.permissions.indexOf("GlobalAccess") !== -1) {
        additionalPermissions = [...additionalPermissions, "ShowInsights", "EditInsights"];
      }

      return additionalPermissions.filter(permission => typePermissions.indexOf(permission) === -1);
    }

    // We need a more long-term way of splitting the enum value from the display name.  It's too hard to rename a permission in the UI right now.
    vm.permissionNames = {
      ShowInsights: "View Analytic Studio Reports",
      EditInsights: "Create and Edit Analytic Studio Reports"
    }


    vm.cancel = function() {
      $state.go(homeState);
      window.location.assign("/#/admin/v2/user");
    }

    vm.cleanPhoneNumber = function(phoneNumber) {
      return phoneNumber.replace(/\D/g,"");
    }

    vm.userStatusIsChanging = false;
    vm.setUserActive = function(isActive) {
      if (vm.userStatusIsChanging) { return }
      vm.userStatusIsChanging = true;
      userManagerService.setUserStatus(vm.user.id, isActive).then(complete => {
        vm.user.enabled = isActive
        vm.statusMessage = isActive ? 'This user has been enabled' : 'This user has been disabled'
      }).finally(() => vm.userStatusIsChanging = false)
    }

    vm.clearResetPasswordModal = function(input) {
      input.confirmPasswordReset.$pristine = true;
      input.confirmPasswordReset.$invalid = false;
      input.passwordReset.$pristine = true;
      input.passwordReset.$invalid = false;
      input.$pristine = true;
      input.$invalid = false;
    }

    vm.cannotEditUserType = true;

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    activate();

    function activate() {
      vm.state = 'Loading';
      vm.formSubmitted = false;
      const editingUserPromise = (vm.mode === 'create')
        ? $q.when(vm.defaultUser())
        : userManagerService.getUser(forceUserId || $stateParams.userId).then(function (resp) {
          return resp.data
        });
      const editingUserPreferencesPromise = (vm.mode === 'create')
        ? $q.when(vm.defaultUserPreferences())
        : userManagerService.getUserPreferences(forceUserId || $stateParams.userId).then(function (resp) {
          return resp.data
        });

      const promises = {
        userMakingEdits: userService.currentUser(true),
        userTypes: userManagerService.userTypes(accountId).then((resp) => resp.data.userTypes),
        userToEdit: editingUserPromise,
        userPreferencesToEdit: editingUserPreferencesPromise,
        canSeeMultipleAccounts: accountsService.canSeeMultipleAccounts(),
        writeableAccountIds: accountsService.listAccounts().then(resp => resp.accounts.map(x => x.id))
      };

      $q.all(promises).then(function({
        userTypes, userMakingEdits, userToEdit, userPreferencesToEdit, canSeeMultipleAccounts, writeableAccountIds
      }) {

        vm.showAccountSelection = canSeeMultipleAccounts && (vm.mode === 'create' || _.contains(writeableAccountIds, userToEdit.accountId))
        vm.user = userToEdit;
        vm.userPreferences = userPreferencesToEdit;
        vm.userMakingEdits = userMakingEdits;

        // yay, 2 different user schema's. One has "id" the other has "userId"
        const isSameUser = vm.user.id === vm.userMakingEdits.userId;
        vm.title = isSameUser ? 'Update Profile' : vm.pageStrings.titleAction + ' User';

        vm.additionalPermissions = {};
        (vm.user.permissionOverrides || []).map(permission => vm.additionalPermissions[permission] = true)

        vm.userTypes = userTypes;
        vm.assignableUserTypes = _.filter(vm.userTypes, ({permissions}) => {
          return permissionLevel(permissions) <= permissionLevel(vm.userMakingEdits.permissions);
        });

        vm.cannotEditUserType = isSameUser || vm.user.provisionedViaSSO || vm.assignableUserTypes.find(x => x.id === vm.user.userType) === undefined;
        if (vm.cannotEditUserType) { // add the userType to the list for display purpose if not editable
          vm.assignableUserTypes = userTypes
        }

        vm.state = 'UserEditing';
      })
    }

    const permissionLevel = permissions => {
      const hierarchy = [
        ["AccountManagement", "UserManagement"],
        ["AccountOwner"],
        ["RoleCreation"],
        ["GlobalAccess"]
      ]

      let highest = -1
      hierarchy.forEach((values, index) => {
        if (intersection(values, permissions).length > 0) {
          highest = index
        }
      })
      return highest
    }
  }
})();
